export default {
  titles: {
    encoding: '編碼',
    inbound: '入境',
    user_info: '使用者資訊',
    settings: '設定',
    reset_daily_items: '重置日常項目',
    last_parcels: '最後的包裹',
    select_item: '選擇物品',
    select_workstation: '選擇工作站',
    select_language: '選擇語言',
    support: '支援',
    select_printer: '選擇印表機',
    shipment_to_confirm: '出貨確認',
    sorting_details: '公開細節',
    inventories: '庫存',
    pin_modal: '輸入 PIN 碼以強制關聯',
    shipments: '出貨量',
    report_problem: '回報問題',
    parcels: '包裹',
    //moncler
    outbound_bthp: '出貨 BTHP 證書'
  },
  simple_parcel_list: {
    to_read: '待讀取',
    ok: '確定',
    force: '強制',
    force_parcel: '強制包裹 {{code}}',
    force_parcel_desc: '輸入使用者 PIN 以強制包裹',
    forced: '已強制',
    unexpected: '意外',
    remove: '移除',
    invalid_pin: '使用者 PIN 無效',
    loading: '載入包裹清單中'
  },
  create_parcel_gate: {
    //moncler
    width: '寬度',
    height: '高度',
    depth: '深度',
    tare: '皮重',
    description: '描述'
  },
  fields: {
    current_location: '目前位置',
    identified_item: '已識別物品',
    ignored_items: '被忽略的項目',
    ignored_with_reason_items: '有理由忽略的項目',
    error_items: '錯誤項目',
    warning_items: '警告事項',
    umg: 'Umg',
    custom_class: '客户等級',
    product_code: '產品編碼',
    as400username: '使用者名稱 AS400',
    item_components: '元件',
    //valentino
    mission: '任務',
    mission_type: '任務類型',
    supplier: '供應商',
    physical_storage: '實體儲存',
    season: '季節',
    ddt: 'DDT',
    notification: '通知',
    ddt_date: 'DDT 日期',
    notification_date: '通知日期',
    product_category: '產品類別',
    sender: '發送者',
    year: '年',
    number: '編號',
    row: '行',
    entity: '實體'
  },
  misc: {
    select_an_option: '選擇一個選項...',
    not_set: '未設定',
    current_value: '當前值',
    pleaseWait: '請稍等',
    not_associated: '未關聯',
    replaced: '已替換',
    production_order_info: '生產訂單資訊',
    reel_info: '卷軸資訊',
    reel_code: '卷軸代碼',
    assigned_supplier: '指定供應商',
    type: '類型',
    identifier_info: '識別資訊',
    identifier_events: '識別事件',
    or: '或者',
    select_place: 'Ciao {{user}}，選擇您的原籍地以繼續',
    back: '後退',
    refresh: '重新整理',
    reload: '重新載入',
    save: '儲存',
    confirm: '確認',
    confirm_auto: '自動確認',
    update_and_confirm: '更新並確認',
    update: '更新',
    no_carton_found: '沒有找到紙箱',
    confirm_continue: '確認並繼續',
    cancel: '取消',
    close: '關閉',
    user: '使用者',
    workstation: '工作站',
    username: '使用者名稱',
    name: '姓名',
    password: '密碼',
    login: '登入',
    encoding: '編碼',
    code: '程式碼',
    ean_code: 'EAN代碼',
    certilogo: '認證標誌',
    enter_the_necessary_fields: '輸入必要的欄位以開始操作',
    associated_items: '相關項目',
    associate: '聯繫',
    associated: '已聯繫',
    verify: '核實',
    verify_association: '核實',
    reading: '讀取中',
    processing: '進行中',
    association: '協會',
    associations: '協會',
    waiting: '等待',
    writing: '寫作',
    writing_progress: '寫入進行中…',
    partial_confirm: '部分確認',
    retry: '重試',
    writing_association: 'Writing and association',
    confirmed: '已確認',
    unable_to_write: '無法為產品：{{productCode}} 寫入 epc 標籤：{{code}}',
    unable_to_get_next_epc: '無法取得下一個 epc：{{productCode}}',
    unable_to_connect_to_workstation: '無法連接到工作站',
    tag_info: '標籤資訊',
    inbound: '入境',
    outbound: '出境',
    stop: '停止',
    start: '開始',
    pause: '暫停',
    clear: '清除',
    tag_encoded_today: '今天標記編碼',
    transaction_date: '交易日期',
    select_transaction_date: '選擇交易日期',
    ready_to_receive: '準備接收',
    change_password: '更改密碼',
    logout: '登出',
    are_you_sure_to_logout: '您真的要退出嗎？',
    settings: '設定',
    roles: '身份',
    email: '電子郵件',
    place: '地方',
    items: '物品',
    description: '描述',
    color: '顏色',
    size: '尺寸',
    part: '部分',
    total_reads: 'TOTAL READS',
    total_ok: 'TOTAL OK',
    save_to_list: '儲存到列表',
    destination: '目的地',
    origin: '地域',
    new_parcel: '新包裹',
    status: '地位',
    parcel: '包裹',
    read_parcel: '閱讀包裹',
    parcels: '包裹',
    shipment: '運輸',
    creation_date: '建立日期',
    search: '搜尋',
    select_search: '搜尋...',
    detail: '細節',
    quantity: '數量（{{數量}}）',
    only_quantity: '數量',
    style: '風格',
    material: '材料',
    shipment_code_auto: '出貨代碼（自動）',
    parcel_code_auto: '包裹代碼（自動）',
    next: '下一個',
    parcels_to_receive: '待接收包裹',
    confirm_parcel: '確認包裹',
    image_missing: '影像缺失',
    image: '影像',
    loading: '載入中...',
    unknown_product: '未知產品',
    unknown_tag: '未知標籤',
    invalid_tag: '無效標籤',
    virgin_tag: '维珍标签',
    tag_not_associated: '标签未关联',
    killed: '已停用',
    stock: '庫存',
    valid: '有效的',
    unknown: '未知',
    actions: '行動',
    reprint: '重印',
    product: '產品',
    product_items: '產品項目',
    identifiers: '身份識別',
    zone: '區',
    report_repair: '報告修復',
    reason: '原因',
    request_code_change: '請求更改程式碼',
    enable_workstation_emulation: 'Enable Workstation emulation',
    enable_browser_print_emulation: 'Enable Browser Print emulation',
    filter: '篩選',
    language: '語言',
    warning: '警告',
    success: '成功',
    info: '資訊',
    checklist: '清單',
    optional: '自選',
    phone: '電話',
    version: '版本',
    printer: '印表機',
    new_shipment: '新貨',
    upc: '統一產品程式碼',
    model_part_color_size: '型號/零件/顏色/尺寸',
    confirm_shipment: '確認出貨',
    receive: '收到',
    delete: '刪除',
    delete_association: '刪除',
    change: '改變',
    from: '由',
    to: '給',
    ignored: '被忽略',
    skipped: '已跳過',
    ignored_with_reason: '有理由忽視',
    yes: '是的',
    no: '不是',
    model: 'Model',
    typology: 'Tipo',
    no_result: '沒有結果',
    expected: '預期的',
    expected_plural: '預期的',
    read: '讀',
    missing: '遺失的',
    unexpected: '不應識別到',
    unexpected_parcel: '不應識別到的包裹',
    ignored_plural: '被忽略',
    serial: '序列',
    priority: '優先事項',
    group: '團體',
    required_quantity: '所需數量',
    sorted_quantity: 'Ventilated qty',
    missing_quantity: '缺少數量',
    barcode: '條碼',
    barcode_bc: '條碼BC',
    sorted_date: 'Ventilation date',
    customer: '顧客姓名',
    list: '清單',
    list_position: '清單位置',
    select_date: '選擇日期',
    item_info: '商品資訊',
    item_events: '專案事件',
    operation_type: '操作類型',
    operation_place: '操作地點',
    loading_data: '請稍候，資料正在載入...',
    empty_item_events: '沒有找到活動',
    show_more: '展示更多',
    hide_more: '隱藏更多',
    production_order: '產品訂單',
    production_order_detail: '生产订单明细',
    production_order_row: '生產訂單行',
    production_order_sku: '生產訂單 SKU',
    kill_tag: '殺死標籤',
    replace_tag: '替換標籤',
    replace_tag_with: '替換標籤與 {{tag}}',
    item_po: '物品訂單',
    item_order: '商品訂單',
    item_row: '物品行列',
    pack_code: '封裝程式碼',
    send_reads: 'Send Reads',
    items_add_inventory_success: '添加到庫存的物品',
    new: '新的',
    confirm_mission: '確認任務',
    confirm_mission_text: '您確定要確認任務嗎？',
    parziali: '部分的',
    total_quantity: '總數量',
    accepted_quantity: '接受數量',
    country_check: '國家控制',
    showcase_check: '展示控制',
    attention: '注意',
    clear_items: '繼續操作將刪除所有讀數，您要繼續嗎？',
    add_partial: '注意力',
    add_partial_text: '可能有必要創建品質保證任務',
    add_partial_already_text: '或有必要創建一個Quality Assurance Mission。 UMG 已啟用。您想覆蓋已讀取的項目嗎？',
    ///
    error_cq_mission: 'Attention, create Mission for Quality Control',
    warning_zone_items: 'IN_ANOTHER_ZONE',
    internal_tag: '內部標籤',
    external_tag: '外部標籤',
    error_tag: '錯誤標籤',
    awaiting: '等待中',
    error_logs: '錯誤logs',
    event_logs: '活動logs',
    box_closed: '盒子關閉',
    box_out: '卡片位',
    unexpected_list: '不應識別到的貨品清單',
    pending_tags: '待處理標籤',
    selected_zone: '選定區域',
    pricing: '價錢',
    send_to_sap: '傳送至 SAP',
    write_tag: '寫入標籤',
    identifier_tag: '識別標籤',
    digit_identifier_tag: '要寫入的數字標籤',
    target_epc: '目標EPC',
    retry_write_tag: '寫入過程中出錯。您想再試一次嗎？',
    ready: '已準備',
    offline: '離線',
    shipping_date: 'Shipping Date',
    update_only_product: 'Item already associated to another product. Are you sure do you want to overwrite it ?',
    update_production_order_row:
      'Item already associated to another production order row. Are you sure do you want to overwrite it ?',
    export: 'Export',
    select_zone: 'Select zone',
    location_origin: 'Location origin',
    confirm_kill_tag: 'Which tags do you want to Kill?',
    kill_in_progress: 'Killing tags in progress',
    confirm_replace_tag: 'Which tags do you want to Replace?',
    replace_in_progress: 'Replacing tags in progress',
    select_tag_to_kill: 'Select the tag you want to kill',
    disassociating_item: 'Disassociating Item',
    killing_tag: 'Killing {{type}} tag with role {{role}}',
    retry_kill_tag: 'A killing error was encountered. Do you want to try killing the tag again?',
    reading_tag: 'Reading Tag',
    writing_tag: 'Writing Tag',
    writing_tag_with: 'Writing tag {{tag}}',
    navBackWarning: 'Are you sure you want to go back? All unsaved changes, such as readings, will be lost.',
    sentry: {
      report_problem: 'Describe the problem you encountered or suggest an improvement'
    },
    ready_to_read: 'Ready to read',
    remove_product_readings: 'Remove product readings',
    ok: 'OK',
    already_in_parcel: 'already in parcel',
    operation_canceled_by_user: 'Operation canceled by user',
    load_more: 'loading in progress',
    input: 'Input',
    rfid_barcodes: 'RFID Barcodes',
    submit: 'Submit',
    //valentino
    error: 'Errore',
    OK_WORKER: 'OK FORNITORE',
    KO_WORKER: 'KO FORNITORE',
    OK_REPAIR: 'OK RIPARAZIONE',
    OK_VALDAGNO: 'OK VALDAGNO',
    KO_VALDAGNO: 'KO VALDAGNO',
    RESO_RICHIESTO_CQ: 'RICHIESTO CQ',
    RESO_OK: 'RESO OK',
    SECOND_VALDAGNO: 'SECONDA SCELTA',
    OK_LINING: 'OK FODERA',
    ok_first_inbound_status: 'OK FIRST INBOUND',
    OK_RISC: 'RISCHIATO',
    KO_LINING: 'KO FODERA',
    size_color: 'Taglia/Colore',
    select_size_color: 'Seleziona taglia/colore',
    print: 'Stampa',
    missings: 'Mancanti',
    embedded: 'Embedded',
    ignoreds: 'Ignorati',
    select_printer: 'Seleziona stampante',
    printing_started: 'Stampa avviata',
    release_reports: 'Verbali di sblocco',
    quality_checks: 'Controlli qualità',
    quality_check: 'Controllo qualità',
    total_mission_qty: 'Qta totale missione',
    inbound_read_qty: 'Qta letta ingresso varco',
    checked_qty: 'Qta controlli effettuati',
    checked: 'Collaudati',
    returned: 'Rientrati',
    damaged: 'Difetti',
    qty_damaged_first_check: 'Qta difettati 1° controllo',
    first_check_date: 'Data 1° controllo',
    qty_damaged_second_check: 'Qta difettati 2° controllo',
    second_check_date: 'Data 2° controllo',
    note: 'Note',
    work_order: 'Work Order',
    order_type: 'Order type',
    //louis vuitton
    start_and_read: 'Veuillez démarrer les antennes et placer le produit',
    emulate: 'Emulate',
    advanced_emulation: 'Advanced Emulation',
    emulation_history: 'Emulation History',
    emulation_favorites: 'Favorites',
    power: 'Power',
    sensitivity: 'Sensitivity',
    expected_quantity: 'Expected',
    extra_quantity: 'Extra',
    encoded_quantity: 'Encoded',
    clear_and_restart: 'Clear & Restart',
    products: '產品',
    last_paired_sn: '最後一個配對的SN',
    last_confirmed_ucs: '最後一個確認的UCS',
    user_manual: '用户手册',
    operation_user_manual: '操作用户手册'
  },
  error: {
    error: '錯誤',
    errors: '錯誤',
    forbidden: '禁止',
    not_found: '未找到',
    product_not_found: '找不到產品',
    unauthorized: '未經授權',
    too_many_tags_read: '讀取的標籤過多（預期 {{expected}} 讀取 {{read}}）',
    too_many_checklist_types: '檢查表類型太多。確保選擇具有相同清單類型的土地。',
    rfid_discrepancies_found: '發現 RFID 差異，清除所有差異並重試或確認差異',
    certilogo_not_found: '未找到憑證“{{code}}”',
    ean_not_found: '未找到 EAN“{{code}}”',
    production_order_not_found: '未找到生產訂單“{{code}}”',
    no_inbound_zones: '無入境區域',
    no_operation_config: '未找到操作配置',
    not_supported_reading_mode: '不支援閱讀模式',
    undefined_operation_config: '操作配置不能未定義',
    certilogo_already_encoded: 'Certilogo「{{code}}」已編碼',
    tag_not_found: '未找到標籤',
    missing_printer_id: '缺少印表機 IP',
    tag_unassociated: '標籤不關聯',
    tag_type_unexpected: '不應識別到的標籤類型',
    tag_already_associated: '標籤已關聯',
    tags_not_associated: '一個或多個標籤未關聯',
    tags_mismatch: '標籤不匹配',
    workstation_could_not_be_started: '工作站 {{code}} 無法啟動',
    antenna_was_started: '天線 {{code}} 已啟動',
    antenna_was_not_started: '天線 {{code}} 未啟動',
    authentication_failed: '認證失敗',
    field_required: '欄位 {{label}} 為必填項',
    unable_to_connect_to_rfid_reader: '無法連接到 RFID 讀取器。檢查設備是否已開啟。',
    items_in_error_found: '發現錯誤的項目',
    item_not_in_inbound: '物品不在入庫中',
    item_not_in_stock: '商品無庫存',
    item_in_another_parcel: '另一個包裹中的物品',
    item_in_another_production_order: '另一個生產訂單中的項目',
    connection: '連線錯誤',
    connection_details: '伺服器沒有響應。檢查您的網際網路連線或 VPN 設定是否正常運作。',
    ///
    field_invalid_default: '欄位 {{field}} 的預設值「{{defaultValue}}」無效',
    field_invalid: '輸入的值無效',
    field_invalid_default_from_endpoint: '找不到欄位 {{field}} 的值',
    sorting_already_read: '序號為 {{serial}} 的項目已在群組 {{group}} 中讀取',
    sorting_no_group: '項目不可排序',
    sorting_not_in_zone: '序號為 {{serial}} 的項目不可排序。已在區域 {{zone}}',
    sorting_unknown: '標籤 {{tag}} 無效',
    sorting_unexpected: '意外標籤',
    no_item_configuration: '未找到項目配置',
    item_creation_error: '物品創建錯誤',
    couldn_find_production_order: '找不到生產訂單',
    couldn_find_production_order_row: '找不到生產訂單行',
    missing_operation_option: '缺少操作選項：{{error}}',
    item_session_list_create: '未建立的列表',
    item_session_list_create_session: '未建立的會話列表',
    item_session_list_confirm: '未確認名單',
    item_session_list_confirm_session: '未確認的會話列表',
    form_validation: '驗證表',
    form_validation_message: '欄位填寫錯誤',
    select_place_error: '無法保存原籍地',
    self_user_data: '無法保存您的數據',
    encoding_no_tags: '沒有讀取更多標籤。手術終止',
    only_virgin_tag: '僅偵測到原始標籤',
    tags_mismatch_error: '偵測到太多產品',
    tags_errors: '標籤錯誤',
    value_not_valid: '輸入的值無效',
    write_tag: '寫入標籤期間發生未知錯誤',
    WRONG_PRODUCTION_ORDER: '生產訂單錯誤',
    WRONG_PLACE: '錯誤的地方',
    PRODUCTION_ORDER_ROW_CREATION_ERROR: '生產訂單行創建錯誤',
    force_tag_associated: '標籤已關聯。重新關聯？',
    operation_confirm_error: '確認操作時發生錯誤',
    missing_mandatory_qc: '沒有品質控制。繼續？',
    wrong_qc_status: 'The product has been declared KO. Proceed?',
    wrong_qc_size: '檢查尺寸。繼續？',
    wrong_qc_size_payload: '檢查尺寸。編碼尺寸：{{productSize}} - 物理尺寸：{{manualSize}}。繼續？',
    wrong_qc_model: '檢查型號。繼續？',
    start_checklist: '取消啟動清單',
    confirm_with_unexpected: '無法確認不應識別到的標籤',
    confirm_with_overqty: '無法確認數量過多的標籤',
    rfid_reader_initialization: 'RFID 讀取器初始化期間出現未知錯誤',
    remove_sap_item_error: '無法刪除項目',
    no_asn_selected: '未選擇 ASN',
    submit_asn: '提交 ASN 時出錯',
    zbpNotFound: '偵測不到 Zebra Browser Print 代理程式，請確認已安裝並正在執行',
    no_printer_selected: '未選擇印表機',
    zplTemplateNotDefined: '未定義 ZPL 範本。請在操作設定的「zpl-template-code」屬性中設定範本代碼',
    ///
    no_print_template: '找不到列印範本',
    wrong_tag: '標籤錯誤',
    tag_error_or_not_authentic: '標籤不真實或認證錯誤',
    authentication_timeout: '認證逾時',
    tid_missing: '讀取的標籤缺少 TID',
    on_destination: '在目的地 {{destination}}',
    item_not_sortable: '序號為 {{serial}} 的項目無法排序',
    search_error: '搜尋錯誤',
    no_parcel_found_by_identifier: '找不到具有此識別碼的包裹',
    kill_tag_not_allowed: '無法刪除關聯項目的標籤。請先解除關聯後再刪除標籤。',
    kill_already_killed: '標籤已刪除',
    can_kill_only_tag_type: '你只能消滅{{type}}標籤',
    ///
    replace_tag_not_allowed: '只能替換已關聯的標籤',
    kill_tag_not_success: '刪除標籤失敗',
    replace_tag_not_success: '替換標籤失敗',
    nfc_tag_not_expected: '此產品不預期有 NFC 標籤',
    ventilation_quantity_reached: '此產品的通風數量已達上限',
    confirm_not_allowed_with_errors: '存在錯誤時無法確認',
    close_not_allowed_with_errors: '存在錯誤時無法關閉',
    generic: '傳送回饋時發生錯誤',
    form_entry: '某些欄位為必填',
    invalid_tag_read: '讀取到無效的標籤',
    read_one_tag_time: '一次只能讀取一個標籤',
    validation_failed_rewrite: '重寫配置驗證失敗',
    uhf_tag_not_found: '找不到 UHF 標籤',
    compute_tags_failed: '生成寫入標籤失敗',
    be_generic_error: '系統錯誤',
    be_generic_error_description: '系統發生一般錯誤。',
    identifier_production_order_not_found: '找不到生產訂單',
    gs1code_invalid: 'GS1 代碼無效',
    productionorderrow_mismatch: '生產訂單行不一致。繼續嗎？',
    //cucinelli
    nfc_already_associated: 'NFC 已關聯。請取消關聯後重試',
    too_many_valid_tag_read: '讀取到過多有效標籤',
    fields_required: '為必填',
    exceeded_quantity: '数量超出',
    production_order_completed: '生产订单完成',
    production_order_row_completed: '生产订单行已完成',
    replace_tag_not_allowed_for_this_tag: 'このタイプのタグを置き換えることはできません',
    box_already_received: '盒子已收到。跳過閱讀。',
    MISSING_EAN_ATTRIBUTE: '商品{{productCode}}的EAN未找到',
    other_production_order: '已关联到不同的生产订单和产品',
    workorder_mismatch:
      '产品已关联到与包装上印刷的生产订单不同的生产订单。请检查产品，如果确认，产品将关联到包装上印刷的生产订单。'
  },
  messages: {
    no_operations_found: '沒有找到任何操作。檢查控制面板上的使用者權限',
    not_allowed_operation: '您沒有執行此操作的權限。請檢查您的設定',
    no_workstations_found: '未找到工作站',
    no_workstation_selected: '未選擇工作站',
    are_you_sure_to_reset_daily_items: '您確定要重置日常項目嗎？',
    bring_an_item_to_antenna: '將物品靠近天線',
    press_start_to_read: '按下“開始”按鈕開始讀取 RFID 產品',
    reading_in_progress: '閱讀進行中',
    waiting_for_product: '等待產品...',
    paste_comma_separeted_tags: '貼上以逗號分隔的標籤，然後按下返回鍵...',
    connection_workstation_progress: '正在連接到工作站..',
    operation_success: '確認操作成功',
    outbound_success: '出境成功確認',
    inbound_success: '入站確認成功',
    pack_success: '包裝成功確認',
    transfer_to_zone_success: '轉移至區域已成功確認',
    simple_item_list_success: '簡單物品清單已成功確認',
    list_empty: '列表為空',
    looks_like_anything_in_list: '您的清單中似乎沒有任何內容',
    generic_success: '{{code}} 已成功確認',
    generic_success_canceled: '{{code}} 成功取消',
    generic_error: '{{code}}錯誤',
    fill_all_fields_and_search_an_item_configuration: '填寫所有欄位並蒐索項目配置',
    encoding_success: '編碼成功確認',
    encoding_success_none: '該項目先前已關聯',
    read_some_identifier_to_start_verification: '讀取一些標識符以開始驗證',
    warning_items_found: '發現警告項目',
    are_you_sure_you_want_to_confirm: '您確定要確認嗎？',
    item_session_list_confirm: '名單確認成功',
    operation_in_progress: '操作正在進行中，請稍候...',
    sorting_error_zones: '"Origin zone not valued, impossible to continue with the ventilation"',
    connection_in_progress: '連接正在進行中...',
    checklist_there_are: '有',
    checklist_missings: '遺失物品',
    checklist_overqty: '超額物品',
    checklist_unexpecteds: '不應識別到的物品',
    checklist_confirm_mismatch_question: '您確定還要確認嗎？',
    force_update_content: '您確定要強制傳送到 SAP 嗎？',
    connection_to_station_in_progress: '正在連接至電台',
    tag_killed: '標籤被殺',
    tag_replaced: 'Tag replaced',
    tag_deleted: '標籤已刪除',
    write_tag: '寫入標籤成功',
    not_ready: 'Non pronta',
    readyf: 'Pronta',
    nfcDecryption: 'Decrittazione tag NFC. Tenere il tag fermo, per favore',
    parcel_success: 'Parcel confermato con successo',
    sentry: {
      success: 'Grazie per il tuo feedback! Il tuo contributo ci aiuta a migliorare il servizio.'
    },
    confirm_force_shipment: 'Conferma la spedizione con PFAS',
    input_rfid_barcodes: 'Inserire i barcode RFID, separati da virgola o accapo',
    //valentino
    are_you_sure_to_clear_reads: 'Sei sicuro di voler cancellare le letture?',
    are_you_sure_to_confirm: 'Sei sicuro di voler confermare?',
    inbound_conveyor_confirm_missing_message:
      'Mancano ancora -missing- articoli da confermare, sei sicuro di voler confermare?',
    newVersionAvailable: '有新版本可用',
    pageWillReload: '頁面將於 30 秒後自動重新載入',
    update_available_description:
      "È disponibile un aggiornamento per questa pagina. Ricarica la pagina per applicare l'aggiornamento.",
    deviceManagerUpdateTitle: 'Aggiornamento Device Manager',
    deviceManagerUpdateDescription:
      'È disponibile un nuovo aggiornamento per il Device Manager (software che integra il lettore RFID). Aggiorna ora per assicurarti un funzionamento ottimale.',
    deviceManagerUpdating: 'Aggiornamento device manager in corso. Per favore attendi il completamento…',
    deviceManagerUpdateCompleted: 'Aggiornamento completato con successo',
    deviceManagerUpdateCompletedAndRequiresReboot: '更新已成功完成。请重新启动系统以应用更新。',
    exceeded_quantity_message: '生产订单行的数量已达到上限。请确保更改该行或生产订单。',
    empty_production_order: '生产订单中不存在任何行',
    empty_production_order_search: '没有符合搜索条件的生产订单行'
  },
  placeholder: {
    search_shipment_parcel: '搜尋貨件或包裹',
    search_product_parcel: '搜尋產品或包裹'
  },
  confirm: {
    discrepancy_title: '包裹有差異',
    discrepancy_message: '發現產品存在差異。您確定要確認包裹嗎？',
    confirm_delete_association: '您確定要刪除該項目關聯嗎？',
    confirm_delete_operation_title: '刪除{{操作}}',
    confirm_delete_operation: '您想刪除該操作嗎？所有讀取的項目都將遺失。',
    confirm_delete_item_association: '您確定要刪除該項目關聯嗎？',
    confirm_kill_tag: '您確定要刪除此標籤嗎？',
    confirm_multiple_kill_tag: 'Are you sure you want to kill all tags?',
    confirm_disassociate_kill_tag: 'Are you sure you want to disassociate and kill {{type}} tag {{tag}}?',
    confirm_disassociate_multiple_kill_tag: 'Are you sure you want to disassociate and kill all tags?',
    confirm_operation_title: '確認{{操作}}',
    confirm_operation_text: '您想確認操作嗎？',
    confirm_operation_text_irreversible: '您想確認操作嗎？此操作無法恢復。',
    confirm_operation_text_partial_confirm: '將讀數發送到 JDE。您確定要繼續嗎？',
    confirm_operation_text_partial_confirm_without_jde: '您確定要繼續嗎？',
    post_confirm_action_title: '繼續',
    post_confirm_action_keep_input: '操作完成。執行另一項操作？',
    post_confirm_action_change_input: '操作完成。執行另一項操作？',
    confirm_close_asn_title: 'Close Confirmation',
    confirm_close_asn_text:
      'Some parcels have not been received. Are you sure you want to FORCE the closing of this shipment?',
    unpack: 'Parcel already packed. Do you want to proceed with the unpack and packing again?',
    last_parcel_confirmerd: '已確認 {{code}} 貨件的所有包裹。是否也關閉貨件?'
  },
  labels: {
    draft: '草稿',
    ready_to_send: '準備發送',
    send_await: '待辦的',
    outbound_error: '出站錯誤',
    sent: '傳送',
    in_inbound: '入境時',
    receive_await: '待辦的',
    ready_to_receive: '收到',
    inbound_error: '入站錯誤',
    received: '已收到',
    in_transit: '在途中'
  },
  serverError: {
    //moncler
    WRONG_ITEM_SUPPLIER: '某些讀取的項目無法由供應商承接。',
    QUANTITY_MISMATCH_ERROR: '輸入的數量與檢測到的數量不符。',
    ZONE_MISMATCH_ERROR: '輸入的區域與檢測到的區域不符。'
  },
  error_messages: {
    password_required: '密碼欄位為必填項',
    invalid_password: '密碼無效',
    //moncler
    missing_workstation_place: '未找到工作站位置。'
  },
  report_tbox: {
    umg: 'Umg',
    ddt_number: 'DDT N.',
    creation_date: '日期',
    capi_mdc: 'Capi MDC',
    qt_totale: '總數量',
    qt_accettata: '接受數量',
    qt_scartata: '拒收數量',
    supplier: '供應商',
    notes: '筆記'
  },
  custom: {
    countTBoxParcel: '包裹',
    countTBoxDDT: 'DDT',
    BARCODE_READ: '條碼讀取',
    RFID_START_READING: '開始讀取',
    RFID_STOP_READING: '停止讀取',
    RESULT_EVENT: '活動結果',
    TRACE: '追查來源',
    INFO: '資訊',
    WARNING: '警告',
    ERROR: '錯誤',
    deleteSession: '刪除包裹',
    deleteSessionMessage: '您確定要刪除該包裹嗎？',
    deleteList: '刪除DDT',
    deleteListMessage: '您確定要刪除 ddt 嗎？',
    WAM: 'SKU',
    sap_warning: 'SAP 警告',
    total_list: '總清單',
    total_parcel: '總包裹數',
    order_number: '訂單編號',
    addon: '添加在',
    componentType: '元件類型',
    //cucinelli
    barcode: 'BC 條碼',
    barcodeBCTrim: 'BC 條碼修剪',
    barcodeJDE: 'JDE 條碼',
    barcodeROQ: 'ROQ 條碼',
    barcodeROQTrim: 'ROQ 條碼修剪',
    class: '類別',
    department: '部門',
    dimensionSystem: '自訂類別',
    ean: 'EAN',
    eanIdPadre: '父 EAN',
    itemId: '項目 ID',
    stagioneROQ: 'ROQ 季節',
    subclass: '型號類型',
    subdepartment: '子部門',
    variantType: '類型',
    variantModel: '變體型號',
    cardCode: '卡號',
    label: '標籤',
    rfidEnabled: '啟用 RFID',
    stato: '狀態',
    ricondizionamentoFornitore: '供應商重整',
    codiceShelf: '庫存儲格',
    montante: '區段',
    ripiano: '儲物格',
    scaffale: '貨架',
    ASSOCIATED: '已關聯',
    NOT_ASSOCIATED: '未關聯',
    REPLACED_ASSOCIATION: '已取代關聯',
    identifiers: '識別碼',
    force_parcel: '強制包裹',
    force_parcel_message: '您確定要強制此包裹嗎？',
    pesa_collo: '頸部重量',
    peso_kg: '重量（公斤）',
    wrong_packaging_code: '包裝代碼錯誤',
    packaging_confirmed_no_weight: '您正在確認無重量包裹，是否繼續？',
    attention: '注意',
    continue: '繼續',
    model: '型號',
    sizeCode: '尺寸代碼',
    sizeDescription: '尺寸描述',
    serial: '序號',
    identifier: '識別碼',
    product: 'BC 條碼',
    shift: '班次',
    destination: '目的地',
    regDate: '日期',
    listPosition: '列表位置',
    list: '列表',
    customerName: '客戶名稱',
    regTime: '時間',
    event: '事件',
    customer: '客戶',
    isCarryover: '結轉',
    carryoverValue: '結轉值',
    madeIn: '產地',
    collectionCode: '系列代碼',
    collectionDescription: '系列描述',
    collectionYear: '年份',
    fatherProductValue: '父產品',
    genderValue: '性別',
    genderValueDescription: '性別描述',
    line: '品牌線',
    lineDescription: '系列描述',
    marchioDescription: '品牌說明',
    marchioValue: '品牌',
    merchandiseClassCode: '類別代碼',
    merchandiseClassDescription: '類別描述',
    merchandiseSubclassCode: '子類別代碼',
    merchandiseSubclassDescription: '子類別描述',
    modelPartColor: '型號部件顏色',
    modelPartColorSizeValue: '型號部件顏色尺寸',
    isPermanent: '永久',
    permanentValue: '永久值',
    isSeasonal: '季節性',
    seasonalValue: '季節值',
    sleeveTypeValue: '袖型',
    origin_location_mandatory_field_error: '必須提供來源地點',
    transactionDate_mandatory_field_error: '必須提供交易日期',
    customerCode_mandatory_field_error: '必須提供客戶代碼',
    tipology_field_error: '必須提供類型',
    warehouseUsa_relabeling_mandatory_fields_error: '必須提供重標記',
    //valentino
    sconosciuto: '未知',
    prodottoSconosciuto: '未知產品',
    reads_ok: '讀取成功',
    tot_to_check: '待檢查總數',
    //moncler
    confirm_force_received_text: '此運送已經確認。您要將其從列表中刪除嗎？',
    confirm_force_received_sap_text: '該出貨已在 SAP 中接收。您想將其從列表中刪除嗎？',
    confirm_force_received_partially_sap_text: '該出貨已在 SAP 中部分接收。請在 SAP 中完成。您想將其從列表中刪除嗎？',
    //louis vuitton
    tooManyTags: '標籤過多',
    nfcDetectedPleaseUseProductControl: '檢測到 NFC 標籤，請使用產品控制功能',
    GENERIC_ERROR: '一般錯誤 - 請透過 ContactIS 聯繫支援',
    ECERTIFICATE_WORKORDER_NOT_FOUND: 'eCertificate 中未找到工作單',
    ITEM_IN_ANOTHER_PARCEL: '此項目已在其他包裹中聲明',
    ECERTIFICATE_WORKORDER_CREATED_BOT_NOT_COMPLETED: 'eCertificate 中已創建工作單但未完成',
    INVALID_TIMESTAMP: '無效時間戳',
    INVALID_SERIAL: '無效序號',
    INVALID_WORKORDER: '無效工作單號',
    INVALID_SKU: '無效 SKU',
    INVALID_PARCEL_NUMBER: '無效包裹號',
    SAP_UCS_NOT_CONFIRMED: 'UCS *{parcelCode} 在組裝線結束時未確認',
    SAP_REMOVABLE_SYNCHRO_NOT_PERFORMED: '未執行可拆卸同步',
    SAP_INCORRECT_OPERATION_STATUS: 'SAP ME 中 UCS *{parcelCode} 的狀態不正確',
    SAP_COMPLETED_NOT_FOUND_IN_TNT: 'UCS 已在 SAP 完成，但在 T&T 中不存在',
    SAP_UCS_CANNOT_BE_COMPLETED: 'UCS *{parcelCode} 無法在 SAP ME/MII 中完成',
    SAP_WORKORDER_CLOSED: 'SAP MII 中 UCS *{parcelCode} 相關的工作單已關閉',
    SAP_INTERNAL_ERROR: 'SAP MII 發生技術錯誤',
    SAP_TIMEOUT_BUT_OK_AGGREGATION: '逾時 → 聚合成功',
    LVSP_PARCEL_NUMBER_ALREADY_AGGREGATED: 'LVSP 中包裹號已聚合',
    LVSP_SERIAL_ALREADY_AGGREGATED: 'LVSP 中序號已聚合',
    LVSP_MISMATCH_EXPECTED_QUANTITY: 'LVSP 掃描數量與預期不符',
    LVSP_SKU_NOT_FOUND: 'LVSP 中未知 SKU',
    LVSP_SUPPLIER_NOT_FOUND: 'LVSP 中供應商未知',
    TECHNICAL_ERROR: '技術問題 - 請透過 ContactIS 聯繫支援',
    ERROR_IN_PARCEL_ITEMS: '確認包裹時發生錯誤，請使用垃圾桶圖示清空並重新掃描所有項目',
    viewCitesDocument: '查看 CITES 文件',
    LV_LE_ERROR_ON_QUANTITY: 'Limited Edition 包裹数量必须为1',
    LV_CUSTOM_DECODE_FAILED: 'LV 标签解码失败',
    ///
    product_is_authentic: '產品為真品',
    not_sellable: '不可銷售，請開啟 NeoContact 工單（放入 WDF 桶）',
    stock_product: '庫存產品：保持可銷售；客戶退貨：可退換並保持可銷售',
    ///
    store_action: '門店操作',
    reprint: '重印',
    reprint_sent: '重印已發送',
    row: '行',
    longSKU: '長 SKU',
    pairingDate: '生產日期',
    citesFlag: 'CITES',
    pairingSupplier: '供應商',
    batchNumber: '批次',
    status: '狀態',
    chrono: '時間序',
    logisticStatus: '產品狀態',
    serialNumber: 'RFID 序號',
    returnCode: '返回代碼',
    // others
    reference: '參考',
    sender: '發件人',
    year: '年份',
    number: '編號',
    TAG_STATUS_CONFIRMED: '已關聯',
    halfpair: '半對'
  },
  imbustatrice: {
    and: '和',
    unkwon_tag: '未知標籤',
    dynamic_tag: '{{身份}}標籤',
    dynamic_tag_missing: '{{身份}} 標籤缺失',
    too_many_dynamic_tags: '{{身份}} 標籤過多',
    dynamic_tag_already_associated: '{{身份}} 標籤已關聯',
    wrong_tag: '標籤錯誤',
    missing_tag: '缺少標籤'
  },
  identifier_error: {
    ALREADY_ASSOCIATED_TAG: '已關聯',
    WRONG_QC_STATUS: '品質控制狀態錯誤',
    WRONG_QC_SIZE: '品質控制尺寸錯誤',
    WRONG_QC_MODEL: '品質控制模型錯誤',
    MISSING_MANDATORY_QC: '缺乏品質控制',
    MISSING_PRODUCT_INFO: '缺少產品資訊',
    WRONG_TAG: '標籤錯誤',
    UNKNOWN_TAG: '未知標籤',
    WRONG_PRODUCT: '錯誤的產品',
    MISSING_MANDATORY_TAG: '缺少強制標籤',
    MISSING_OPTIONAL_TAG: '缺少可選標籤',
    EXTRA_TAG: '額外標籤',
    TAG_MISMATCH: '標籤不匹配',
    PRODUCTIONORDERROW_MISMATCH: '生產訂單行關聯不匹配',
    MISSING_SYSTEM_TAG: '未知標籤',
    UNEXPECTED_TAG: '意外標籤',
    NOT_EXISTING_CERTILOGO_TAG: '憑證代碼不在系統中',
    KILLED_TAG: '已刪除標籤',
    MISSING_TAG: 'Missing tag',
    TOOL_DETECTED: 'Tool tag detected'
  },
  statuses: {
    RESTORE_VARIANT: '恢复类型',
    CONFIRM_ERROR: '确认错误'
  },
  userSettings: {
    title: '使用者設定',
    autostopAntennaTimeout: '自動停止天線超時 (毫秒)',
    autostartAntenna: '自動啟動天線',
    autoConfirmParcel: '自動確認包裹',
    barcodeItemRead: '條碼項目讀取',
    antennas: '天線設定',
    resetReadingsAfterOperation: '确认后复位速度',
    slow: '慢',
    medium: '中',
    fast: '快',
    printerCode: '印表機代碼',
    enableOkSounds: 'OK 聲音',
    enableKoSounds: 'KO 聲音'
  },
  attributes: {
    material: '材質',
    workerCode: '作業員代碼',
    workerExternalCode: '外部作業員代碼',
    workerIdentifier: '作業員識別碼',
    workerDescription: '作業員描述',
    workerType: '作業員類型',
    orderCode: '訂單代碼',
    sapQualityControlStatus: 'SAP 品質控制狀態',
    quantityOkWorker: 'OK 作業員 數量',
    quantityKoWorker: 'KO 作業員 數量',
    quantityOkRepair: 'OK 維修 數量',
    quantityOkValdagno: 'OK Valdagno 數量',
    quantityOkFirstInbound: 'OK 首次入庫 數量',
    quantityOkRis: 'RISK 數量',
    quantityKoValdagno: 'KO Valdagno 數量',
    quantitySecondValdagno: 'SECOND CHOICE 數量',
    quantityOkLining: 'OK 內襯 數量',
    quantityKoLining: 'KO 內襯 數量'
  },
  title: {
    report_problem: '回報問題',
    delete_shipment_title: '刪除確認'
  },
  subtitle: {
    report_problem: '請描述您遇到的問題或提出改進建議',
    delete_shipment_message: '您確定要刪除此出貨嗎？'
  },
  label: {
    name: '名稱',
    email: '電子郵件',
    description: '問題描述',
    close: '關閉',
    submit: '提交回饋'
  },
  success: {
    message: '感謝您的回饋！'
  },
  button: {
    submit: '提交回饋'
  }
}
